import GovDevice, { ModifyGovDevice } from "./GovPoolModel/GovDevice"
import { ObservableFromFetch } from "../ObservableFromFetch"

export default function GovDeviceGetObservable(labAccount: string) {
  return ObservableFromFetch<GovDevice[]>(`GovPool/GetDevices?laboratoryAccount=${labAccount}`)
}

export function DevicesGetObservable(labAccount: string = "") {
  const params: string = JSON.stringify({
    LabAccount: labAccount
  })
  return ObservableFromFetch<GovDevice[]>("GovPool/GetCommonDevices", params)
}

export function GovDeviceModifyObservable(data: ModifyGovDevice) {
  const params: string = JSON.stringify(data)

  return ObservableFromFetch<string>("GovPool/ModifyGovDevice", params)
}